/*!
 * @nox/icons - custom element <nox-icon>
 *
 *   <link rel="stylesheet" href="https://<conta>.blob.core.windows.net/icons/v1.0.0/nox-icons.css">
 *   <script src="https://<conta>.blob.core.windows.net/icons/v1.0.0/nox-icon.js" defer></script>
 *
 *   <nox-icon name="carrinho" class="nox-2x"></nox-icon>
 *   <nox-icon name="pizza" class="nox-4x"></nox-icon>
 *   <nox-icon name="fechar" label="Fechar"></nox-icon>
 *
 * Dois tipos de icone, resolvidos automaticamente pelo nome:
 *   - flat -> <svg><use href="sprite.svg#nome"> ... cor herdada via currentColor
 *   - 3D   -> <img src="3d/nome.webp" srcset="... nome@3x.webp 348w"> ... raster, cor propria
 *             (3d/nome.png fica de fallback; a versao @3x vem sozinha em tela retina ou icone grande)
 *
 * Onde estao os arquivos:
 *   - padrao: o build embute os enderecos do blob (package.json > noxIcons), entao quem carrega
 *     o nox-icon.js publicado nao precisa configurar nada
 *   - pra sobrescrever, definir ANTES de carregar este script:
 *       uma pasta com sprite.svg + 3d/:  window.NOX_ICONS_BASE = 'https://.../nox-icons/'
 *       flat e 3D em pastas separadas:   window.NOX_ICONS_SPRITE_URL  = 'https://.../nox-icons-flat/sprite.svg'
 *                                        window.NOX_ICONS_RASTER_BASE = 'https://.../nox-icons/'  (-> nome.webp)
 *   Precedencia: SPRITE_URL/RASTER_BASE > NOX_ICONS_BASE > enderecos embutidos > pasta do script.
 *
 * Sobre o sprite: <use> com referencia externa so' funciona same-origin -- e' regra de
 * seguranca do browser, CORS nao levanta ela. Entao quando o sprite mora em outra origem
 * (blob/CDN), ele e' baixado uma unica vez e injetado escondido no documento, e o <use>
 * passa a apontar pra "#nome" (referencia same-document). O fetch exige CORS no container.
 *
 * Sem shadow DOM de proposito: e' o que deixa as classes utilitarias (nox-2x, nox-spin...)
 * e a cor do tema do tenant (currentColor) atravessarem ate' o SVG.
 */
(function (root, factory) {
  if (typeof module === 'object' && module.exports) {
    // node (testes / SSR): exporta a fabrica, nao registra nada sozinho
    module.exports = factory();
  } else {
    factory().install(root);
  }
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  var SVG_NS = 'http://www.w3.org/2000/svg';
  var XLINK_NS = 'http://www.w3.org/1999/xlink';
  var TAG_NAME = 'nox-icon';
  var SPRITE_FILE = 'sprite.svg';
  var RASTER_DIR = '3d/';
  var RASTER_EXT = '.webp'; // precisa bater com RASTER_EXT de scripts/build.js
  var RASTER_HI = '@3x'; // versao 3x (348 px), precisa bater com RASTER_HI de scripts/build.js
  var RASTER_SIZE = 116; // lado do master em px

  // Marcador @raster-icons: o build troca esta linha pela lista real de icones de icons-3d/.
  // Assim o element sabe, sem request extra, quais nomes sao raster e quais vem do sprite.
  var RASTER_ICONS = ["acai-bowl","acaraje","add-ons","apple","avocado","bacon","bagel","baguette","baiao-de-dois","banana","bao-basket","beer","beer-bottle","beer-combo","beer-mug","beer-pint","beer-tasting","bell-pepper","best-seller","bibimbap","blueberry","boiled-egg","bread-loaf","brigadeiro","broccoli","brownie","burger","burrito","butter","caipirinha","cake","cake-slice","caldo-de-cana","candy","cappuccino","carne-de-sol","carrot","cereal-bowl","champagne","cheese","cheesecake","cherry","chicken-nuggets","chicken-wings","chili-pepper","chips","chocolate-bar","churros","citrus-bowl","cocktail","coconut","coconut-water","coffee","combo","condiments","cookies","corn","coxinha","crab","craft-beer","crepe","croissant","cucumber","cupcake","curry","cuscuz","delivery-bag","donut","draft-beer","drumstick","eggplant","empanada","energy-drink","escondidinho","esfiha","falafel","farofa","feijao-tropeiro","feijoada","fish","fish-and-chips","french-toast","fried-chicken","fried-egg","fried-rice","fries","garlic","gluten-free","gnocchi","granola","grapes","green-apple","grilled-chicken","growler","guarana","gummy-bears","gyoza-basket","ham","honey","hot-chocolate","hot-dog","hot-pot","ice-cream","ipa","kebab","kibe","kids-meal","kiwi","kombucha","lager","lamb-chop","lasagna","lemon","lemonade","lettuce","lobster","lollipop","long-neck","mac-and-cheese","macaron","mango","marmita","meatballs","melon","milk","milkshake","moqueca","muffin","mushroom","nachos","new-item","non-alcoholic-beer","noodles","nuts","oatmeal","olive-oil","omelette","onigiri","onion","onion-rings","orange","orange-juice","orange-slice","oyster","paella","pamonha","pancakes","pao-de-queijo","papaya","parmegiana","passion-fruit","pastel","peach","pear","picanha","pie","pilsen","pineapple","pizza","poke-bowl","popcorn","popsicle","pork-chop","potato","prato-feito","pretzel","promo","pudim","pumpkin","quesadilla","quindim","ravioli","red-ale","ribs","rice-and-beans","risotto","roast-chicken","sake","salad","salami","salmon","sandwich","sashimi","sausage","shawarma","shrimp","side-dishes","skewer","smoothie","soda","soup","soup-cream","spaghetti","spices","spicy","spring-roll","squid","steak","steak-and-fries","stew","sticky-rice","stout","strawberry","strogonoff","sushi","sweet-potato","taco","tamale","tapioca","tea","temaki","toast","tomato","vegan","waffle","water-bottle","watermelon","weiss","whisky","wine","wrap","yogurt"];

  // Marcador @default-assets: o build troca pelos enderecos do blob ({ spriteUrl, rasterBase }).
  // Com isso, trocar o blob de lugar = publicar um nox-icon.js novo, sem mexer nos projetos.
  var DEFAULT_ASSETS = {"spriteUrl":"https://noxmobarquivos.blob.core.windows.net/obamenu/assets/nox-icons-flat/sprite.svg","rasterBase":"https://noxmobarquivos.blob.core.windows.net/obamenu/assets/nox-icons/"};

  function trailingSlash(url) {
    return url.charAt(url.length - 1) === '/' ? url : url + '/';
  }

  // Resolve a base como a pasta do proprio script: .../v1.0.0/nox-icon.js -> .../v1.0.0/
  function resolveBaseUrl(scriptSrc) {
    if (!scriptSrc) {
      return '';
    }

    var withoutQuery = String(scriptSrc).split(/[?#]/)[0];
    var lastSlash = withoutQuery.lastIndexOf('/');

    return lastSlash === -1 ? '' : withoutQuery.slice(0, lastSlash + 1);
  }

  // Ordem de precedencia: window.NOX_ICONS_BASE > data-nox-base no <script> > pasta do script
  function initialBaseUrl(win) {
    if (win.NOX_ICONS_BASE) {
      return trailingSlash(String(win.NOX_ICONS_BASE));
    }

    var doc = win.document;
    var script = doc.currentScript || doc.querySelector('script[data-nox-base]');

    if (script) {
      var declared = script.getAttribute('data-nox-base');
      if (declared) {
        return trailingSlash(declared);
      }
      return resolveBaseUrl(script.src || script.getAttribute('src'));
    }

    return '';
  }

  function install(win, options) {
    var doc = win && win.document;

    if (!doc || typeof win.HTMLElement !== 'function' || !win.customElements) {
      return null;
    }

    var api = win.NoxIcons;

    // ja instalado (script carregado duas vezes): nao redefine o elemento
    if (api && api.version) {
      return api;
    }

    options = options || {};

    var baseUrl = options.baseUrl ? trailingSlash(String(options.baseUrl)) : initialBaseUrl(win);
    // Base declarada pelo projeto ganha dos enderecos embutidos: quem configurou, sabe o que quer.
    // So' a pasta do proprio script (sem declarar nada) nao conta como declaracao.
    var declaredBase = !!(options.baseUrl || win.NOX_ICONS_BASE || win.document.querySelector('script[data-nox-base]'));
    var defaults = declaredBase ? {} : options.defaultAssets || DEFAULT_ASSETS;
    // Sobrescritas pra quando flat e 3D moram em pastas diferentes (null = deriva do baseUrl)
    var spriteUrlOverride = optionalUrl(options.spriteUrl || win.NOX_ICONS_SPRITE_URL || defaults.spriteUrl);
    var rasterBaseOverride = optionalFolder(options.rasterBase || win.NOX_ICONS_RASTER_BASE || defaults.rasterBase);
    var rasterIcons = new win.Set(options.rasterIcons || RASTER_ICONS);
    var mounted = new win.Set();
    var renderToken = new win.WeakMap();
    var token = 0;
    var spritePromise = null;
    var spriteInjected = false;
    var spriteHost = null;

    function optionalUrl(value) {
      return value ? String(value) : null;
    }

    function optionalFolder(value) {
      return value ? trailingSlash(String(value)) : null;
    }

    function spriteUrl() {
      return spriteUrlOverride || baseUrl + SPRITE_FILE;
    }

    function rasterUrl(name, suffix) {
      return (rasterBaseOverride || baseUrl + RASTER_DIR) + name + (suffix || '') + RASTER_EXT;
    }

    // Tamanho exibido do icone = 1em (font-size do elemento). O navegador multiplica pela densidade
    // da tela e escolhe a menor imagem que cobre: 116w no comum, 348w em retina ou icone grande.
    // "auto" deixa browsers que suportam (lazy + sizes=auto) usarem o tamanho real do layout.
    function rasterSizes(el) {
      var px = 0;
      try {
        px = parseFloat(win.getComputedStyle(el).fontSize);
      } catch (error) {
        px = 0;
      }
      return 'auto, ' + (px > 0 ? Math.ceil(px) : RASTER_SIZE) + 'px';
    }

    // O <use> externo so' vale same-origin; fora disso o sprite precisa ser injetado.
    function spriteIsCrossOrigin() {
      try {
        return new win.URL(spriteUrl(), win.location.href).origin !== win.location.origin;
      } catch (error) {
        return false;
      }
    }

    function warn(message, error) {
      if (win.console && win.console.warn) {
        win.console.warn('[nox-icons] ' + message, error || '');
      }
    }

    function injectSprite(markup) {
      var parsed = new win.DOMParser().parseFromString(markup, 'image/svg+xml');
      var node = parsed.documentElement;

      if (!node || node.nodeName === 'parsererror' || node.getElementsByTagName('parsererror').length) {
        throw new Error('sprite invalido em ' + spriteUrl());
      }

      var host = doc.importNode(node, true);

      // display:none quebra o <use> em alguns engines - o jeito seguro e' tirar do fluxo
      host.setAttribute('aria-hidden', 'true');
      host.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      host.setAttribute('data-nox-sprite', spriteUrl());

      doc.body.insertBefore(host, doc.body.firstChild);
      spriteInjected = true;
      spriteHost = host;

      return host;
    }

    // Mudou a origem dos arquivos: descarta o sprite injetado (senao os <symbol> antigos,
    // com os mesmos ids, continuariam valendo) e re-renderiza o que esta' na tela.
    function reloadAssets() {
      if (spriteHost && spriteHost.parentNode) {
        spriteHost.parentNode.removeChild(spriteHost);
      }

      spriteHost = null;
      spritePromise = null;
      spriteInjected = false;
      mounted.forEach(render);
    }

    // Uma unica requisicao por pagina, compartilhada por todos os icones.
    function ensureSprite() {
      if (!spritePromise) {
        spritePromise = Promise.resolve()
          .then(function () {
            if (typeof win.fetch !== 'function') {
              throw new Error('fetch indisponivel');
            }
            return win.fetch(spriteUrl(), { credentials: 'omit' });
          })
          .then(function (response) {
            if (!response.ok) {
              throw new Error('HTTP ' + response.status);
            }
            return response.text();
          })
          .then(injectSprite)
          .catch(function (error) {
            warn('nao foi possivel carregar ' + spriteUrl() + ' (o container precisa de regra de CORS)', error);
            return null;
          });
      }

      return spritePromise;
    }

    function replaceChild(el, node) {
      el.textContent = '';
      el.appendChild(node);
      return node;
    }

    function applyLabel(node, label, isImage) {
      if (isImage) {
        // alt vazio ja' marca a imagem como decorativa pro leitor de tela
        node.setAttribute('alt', label || '');
        return;
      }

      if (label) {
        node.setAttribute('role', 'img');
        node.setAttribute('aria-label', label);
        node.removeAttribute('aria-hidden');
      } else {
        // icone decorativo: escondido de leitores de tela (default do Font Awesome)
        node.setAttribute('aria-hidden', 'true');
        node.removeAttribute('role');
        node.removeAttribute('aria-label');
      }
    }

    function svgShell(el) {
      var current = el.firstElementChild;

      if (current && current.namespaceURI === SVG_NS) {
        return current;
      }

      var svg = doc.createElementNS(SVG_NS, 'svg');

      svg.setAttribute('class', 'nox-icon');
      // focusable=false: o IE/Edge legado colocava SVG na ordem de tabulacao
      svg.setAttribute('focusable', 'false');
      svg.appendChild(doc.createElementNS(SVG_NS, 'use'));

      return replaceChild(el, svg);
    }

    function imageShell(el) {
      var current = el.firstElementChild;

      if (current && current.tagName === 'IMG') {
        return current;
      }

      var img = doc.createElement('img');

      img.setAttribute('class', 'nox-icon nox-icon-raster');
      img.setAttribute('loading', 'lazy');
      img.setAttribute('decoding', 'async');

      return replaceChild(el, img);
    }

    function setUse(svg, href) {
      var use = svg.firstElementChild;

      use.setAttribute('href', href);
      // xlink:href e' ignorado por browsers modernos, mas Safari < 13 so entende ele
      use.setAttributeNS(XLINK_NS, 'xlink:href', href);
    }

    function renderRaster(el, name, label) {
      var img = imageShell(el);

      var custom = el.getAttribute('src');

      img.setAttribute('src', custom || rasterUrl(name));
      if (custom) {
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
      } else {
        img.setAttribute('srcset', rasterUrl(name) + ' ' + RASTER_SIZE + 'w, ' + rasterUrl(name, RASTER_HI) + ' ' + RASTER_SIZE * 3 + 'w');
        img.setAttribute('sizes', rasterSizes(el));
      }
      applyLabel(img, label, true);
    }

    function renderFlat(el, name, label) {
      var svg = svgShell(el);
      var override = el.getAttribute('sprite');

      applyLabel(svg, label, false);

      if (override) {
        setUse(svg, override + '#' + name);
        return;
      }

      if (!spriteIsCrossOrigin()) {
        setUse(svg, spriteUrl() + '#' + name);
        return;
      }

      if (spriteInjected) {
        setUse(svg, '#' + name);
        return;
      }

      // sprite ainda em voo: so' aponta o <use> depois que ele estiver no documento,
      // e so' se o icone nao tiver mudado de nome nesse meio tempo
      var current = renderToken.get(el);

      ensureSprite().then(function (host) {
        if (host && renderToken.get(el) === current && el.isConnected) {
          setUse(svgShell(el), '#' + name);
        }
      });
    }

    function render(el) {
      renderToken.set(el, ++token);

      var name = el.getAttribute('name');

      if (!name) {
        el.textContent = '';
        return;
      }

      var label = el.getAttribute('label');

      if (rasterIcons.has(name)) {
        renderRaster(el, name, label);
      } else {
        renderFlat(el, name, label);
      }
    }

    var NoxIconElement = function () {
      return Reflect.construct(win.HTMLElement, [], NoxIconElement);
    };

    NoxIconElement.prototype = Object.create(win.HTMLElement.prototype, {
      constructor: { value: NoxIconElement, writable: true, configurable: true },
    });
    Object.setPrototypeOf(NoxIconElement, win.HTMLElement);

    NoxIconElement.observedAttributes = ['name', 'sprite', 'src', 'label'];

    NoxIconElement.prototype.connectedCallback = function () {
      mounted.add(this);
      render(this);
    };

    NoxIconElement.prototype.disconnectedCallback = function () {
      mounted.delete(this);
    };

    NoxIconElement.prototype.attributeChangedCallback = function (_name, previous, next) {
      if (previous !== next && this.isConnected) {
        render(this);
      }
    };

    win.customElements.define(TAG_NAME, NoxIconElement);

    api = {
      version: '1',
      Element: NoxIconElement,
      getBaseUrl: function () {
        return baseUrl;
      },
      getSpriteUrl: spriteUrl,
      getRasterUrl: rasterUrl,
      isRaster: function (name) {
        return rasterIcons.has(name);
      },
      // troca a versao/origem dos assets em runtime e re-renderiza o que ja' esta' na tela
      setBaseUrl: function (next) {
        baseUrl = trailingSlash(String(next));
        reloadAssets();
        return baseUrl;
      },
      // configura qualquer combinacao de { baseUrl, spriteUrl, rasterBase } de uma vez.
      // Chave presente com valor vazio/null remove a sobrescrita e volta a derivar do baseUrl.
      configure: function (config) {
        config = config || {};

        if (config.baseUrl) {
          baseUrl = trailingSlash(String(config.baseUrl));
        }
        if ('spriteUrl' in config) {
          spriteUrlOverride = optionalUrl(config.spriteUrl);
        }
        if ('rasterBase' in config) {
          rasterBaseOverride = optionalFolder(config.rasterBase);
        }

        reloadAssets();

        return { baseUrl: baseUrl, spriteUrl: spriteUrl(), rasterBase: rasterBaseOverride || baseUrl + RASTER_DIR };
      },
      // opcional: baixa o sprite antes do primeiro icone aparecer (ex.: no bootstrap do app)
      preload: function () {
        return spriteIsCrossOrigin() ? ensureSprite() : Promise.resolve(null);
      },
    };

    win.NoxIcons = api;

    return api;
  }

  return {
    install: install,
    resolveBaseUrl: resolveBaseUrl,
    initialBaseUrl: initialBaseUrl,
    trailingSlash: trailingSlash,
    RASTER_ICONS: RASTER_ICONS,
    DEFAULT_ASSETS: DEFAULT_ASSETS,
    TAG_NAME: TAG_NAME,
    SPRITE_FILE: SPRITE_FILE,
  };
});
